import { render, staticRenderFns } from "./ViewAccounts.vue?vue&type=template&id=27d5a60e&"
import script from "./ViewAccounts.vue?vue&type=script&lang=js&"
export * from "./ViewAccounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports